import { Loader2 } from "lucide-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Button } from "../../ui/button";

interface TooltipActionProps {
  icon: ReactNode;
  label: string;
  onClick?: (e: React.MouseEvent) => void;
  to?: string;
  openInNewTab?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
}

const TooltipAction = ({
  icon,
  label,
  onClick,
  to,
  openInNewTab,
  disabled = false,
  isLoading = false,
}: TooltipActionProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (openInNewTab && to) {
      window.open(to, "_blank", "noopener,noreferrer");
    } else if (onClick) {
      onClick(e);
    }
  };

  const content = (
    <>
      <div className="flex h-full shrink-0 items-center justify-start">
        {isLoading ? <Loader2 className="inline h-3 w-3 animate-spin" /> : icon}
      </div>
      <div className="text-left">
        <span className="whitespace-nowrap text-xs font-medium">{label}</span>
      </div>
    </>
  );

  return to && !openInNewTab ? (
    <Link to={to} onClick={handleClick}>
      <Button
        variant="blueOutline"
        className="flex w-full shrink-0 items-center justify-start gap-2 whitespace-nowrap"
        disabled={disabled || isLoading}
      >
        {content}
      </Button>
    </Link>
  ) : (
    <Button
      variant="blueOutline"
      className="flex w-full shrink-0 items-center justify-start gap-2 whitespace-nowrap"
      onClick={handleClick}
      disabled={disabled || isLoading}
    >
      {content}
    </Button>
  );
};

export default TooltipAction;
